import { CompanyProvider } from "../CompanyProvider";
import { ApiClientFactory } from "./clients";

export class CompanyProviderFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/company`);
  }

  createCompanyProvider(authToken: string): CompanyProvider {
    return new CompanyProvider(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
